/**
 * MergedComposer icons — MUI-only glyphs for the Create / Execute tabs.
 * Color and gradient come from CSS on the wrapping `.mcTabGlyph` (see
 * MergedComposer.module.css); the icons themselves inherit currentColor.
 */
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import RouteRoundedIcon from '@mui/icons-material/RouteRounded'

export const SparkleIcon = ({ size = 15 }: { size?: number }) => (
  <AutoAwesomeRoundedIcon style={{ fontSize: size }} aria-hidden="true" focusable="false" />
)

export const JourneyIcon = ({ size = 16 }: { size?: number }) => (
  <RouteRoundedIcon style={{ fontSize: size }} aria-hidden="true" focusable="false" />
)
